import React, { FC, useCallback } from "react";
import {
  CardCvvElement,
  IndividualElementChangeEvent,
} from "@recurly/react-recurly";
import cx from "classnames";
import { dataTestIds } from "data-testids";
import CardElementWrapper, {
  CardElementWrapperProps,
} from "./CardElementWrapper";
import useScrollBillingField from "../../hooks/useScrollBillingField";
import { FieldNames } from "../../constants";

interface Props extends CardElementWrapperProps {
  placeholder?: string;
  shouldScroll?: boolean;
  removeError: (field: string) => void;
}

const Cvv: FC<Props> = ({
  label,
  annex,
  placeholder = "",
  shouldScroll,
  validationMessage,
  removeError,
}) => {
  const ref = useScrollBillingField(!!(validationMessage && shouldScroll));

  const onChange = useCallback(
    (data: IndividualElementChangeEvent) => {
      if (data.valid) {
        removeError(FieldNames.cvv);
      }
    },
    [removeError]
  );

  return (
    <div
      ref={ref}
      className="flex-[1]"
      data-testid={
        dataTestIds.componentLibrary["Organisms.Billing.CardElements.cvv"]
      }
    >
      <CardElementWrapper
        label={label}
        annex={annex}
        validationMessage={validationMessage}
      >
        <CardCvvElement
          className={cx("card-element", { invalid: !!validationMessage })}
          style={{
            fontSize: "18px",
            placeholder: { content: placeholder },
          }}
          onChange={onChange}
        />
      </CardElementWrapper>
    </div>
  );
};

export default Cvv;
